import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  Checkbox,
  IconButton,
  Avatar,
  Stack,
  Divider,
  TextField,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import { TransButton } from '../../common/TransButton';
import { FirebaseImageUpload } from '../../common/FirebaseImageUpload';
import Axios from "axios";
import { Config } from "../../../utils/commonFuctions/Token";
import { base_url } from '../../backendurl/url';
import ModalPopUp from '../../common/TransForm/ModalPopUp';
import { Notification } from '../../common/Notification';

// console.log(Config, "Config222")

//Pefect Edit Flow Before Change Restriction Error Message
// const EditGameModal = ({ open, onClose, onSave, gameData, onRefreshGames }) => {
//   const [gameName, setGameName] = useState('');
//   const [gameLogoFile, setGameLogoFile] = useState(null);
//   const [gameLogoPreview, setGameLogoPreview] = useState('');
//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   // Initialize form with existing game data
//   useEffect(() => {
//     if (gameData) {
//       setGameName(gameData.game_name || '');
//       setGameLogoPreview(gameData.logo || '');
//       setGameLogoFile(null);
//       setUploadError('');
//     }
//   }, [gameData]);

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setGameLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setGameLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpdate = async (shouldRefresh = false) => {
//     if (!gameName.trim()) {
//       setUploadError('Game name is required');
//       return;
//     }

//     if (!gameData?.id) {
//       setUploadError('Game ID is missing');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = gameData.logo; // Keep existing logo by default

//       // Upload new image to Firebase if file is selected
//       if (gameLogoFile) {
//         const uploadResult = await FirebaseImageUpload(gameLogoFile);
//         // Remove query parameters from Firebase URL as done in AdvBannersForm
//         firebaseImageUrl = uploadResult.split('&')[0];
//       }

//       //console.log("firebaseImageUrl", firebaseImageUrl);

//       const gamePayload = {
//         game_name: gameName,
//         // Only include logo in payload if it's changed
//         ...(gameLogoFile && { logo: firebaseImageUrl })
//       };

//       // Call API to update game
//       const response = await Axios.put(`${base_url}/api/pot/games/${gameData.id}/`,
//         gamePayload,
//         Config
//       );

//       console.log(response, "update response");

//       // If API call successful, create updated game object
//       if (response.data) {
//         const updatedGame = {
//           ...gameData,
//           game_name: gameName,
//           logo: firebaseImageUrl,
//           updated_at: new Date().toISOString(),
//           updated_by: 'user',
//           ...response.data // Include any additional data from API response
//         };

//         onSave(updatedGame);
//         handleCancel(); // Reset form
//         console.log('Game updated successfully:', response.data);
//         if (shouldRefresh && onRefreshGames) {
//           onRefreshGames();
//         }
//       }
//     } catch (error) {
//       console.error('Error updating game:', error);
//       setUploadError('Failed to update game. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameName('');
//     setGameLogoFile(null);
//     setGameLogoPreview('');
//     setUploadError('');
//     setIsUploading(false);
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Edit Sport
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//           {/* Game Name Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Sport Name *
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter the sport name"
//               value={gameName}
//               onChange={(e) => setGameName(e.target.value)}
//               disabled={isUploading}
//               error={!gameName.trim() && uploadError.includes('Game name')}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '8px',
//                   '& fieldset': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover fieldset': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: '#3C50E0',
//                   },
//                 },
//                 '& .MuiInputBase-input': {
//                   padding: '12px 14px',
//                   fontSize: '14px'
//                 }
//               }}
//             />
//           </Box>

//           {/* Game Logo Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Sport Logo
//             </Typography>

//             <Box
//               sx={{
//                 border: '2px dashed #D1D5DB',
//                 borderRadius: '8px',
//                 p: 4,
//                 textAlign: 'center',
//                 cursor: isUploading ? 'not-allowed' : 'pointer',
//                 transition: 'all 0.2s',
//                 opacity: isUploading ? 0.6 : 1,
//                 '&:hover': !isUploading && {
//                   borderColor: '#9CA3AF',
//                   backgroundColor: '#F9FAFB'
//                 }
//               }}
//               onClick={() => !isUploading && document.getElementById('edit-file-upload').click()}
//             >
//               {isUploading ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                     Uploading image...
//                   </Typography>
//                 </Box>
//               ) : gameLogoPreview ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <img
//                     src={gameLogoPreview}
//                     alt="Sport logo preview"
//                     style={{
//                       width: '60px',
//                       height: '60px',
//                       objectFit: 'cover',
//                       borderRadius: '8px'
//                     }}
//                   />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                     Click to change logo
//                   </Typography>
//                 </Box>
//               ) : (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                     Click to upload sport logo
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                     PNG, JPG, GIF up to 10MB
//                   </Typography>
//                 </Box>
//               )}

//               <input
//                 id="edit-file-upload"
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFileUpload}
//                 disabled={isUploading}
//                 style={{ display: 'none' }}
//               />
//             </Box>

//             {/* Error Message */}
//             {uploadError && (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#EF4444',
//                   fontSize: '12px',
//                   mt: 1
//                 }}
//               >
//                 {uploadError}
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleUpdate}
//           disabled={!gameName.trim() || isUploading}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

const EditGameModal = ({ open, onClose, onSave, gameData, onRefreshGames }) => {
  const [gameName, setGameName] = useState('');
  const [gameLogoFile, setGameLogoFile] = useState(null);
  const [gameLogoPreview, setGameLogoPreview] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  
  // Notification states
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationType, setNotificationType] = useState('error');

  // Function to show notification
  const showErrorNotification = (message) => {
    setNotificationMessage(message);
    setNotificationType('error');
    setShowNotification(true);
  };

  // Function to validate image dimensions
  const validateImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        if (width > 100 || height > 100) {
          reject(`Image dimensions should not exceed 100x100 pixels. Current dimensions: ${width}x${height} pixels.`);
        } else {
          resolve();
        }
      };
      img.onerror = () => {
        reject('Error loading image for validation.');
      };
      img.src = URL.createObjectURL(file);
    });
  };

  // Initialize form with existing game data
  useEffect(() => {
    if (gameData) {
      setGameName(gameData.game_name || '');
      setGameLogoPreview(gameData.logo || '');
      setGameLogoFile(null);
      setUploadError('');
      setShowNotification(false);
      setNotificationMessage('');
    }
  }, [gameData]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        const errorMsg = 'Please select an image file';
        setUploadError(errorMsg);
        showErrorNotification(errorMsg);
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        const errorMsg = 'File size should be less than 10MB';
        setUploadError(errorMsg);
        showErrorNotification(errorMsg);
        return;
      }

      try {
        // Validate image dimensions
        await validateImageDimensions(file);
        
        setUploadError('');
        setGameLogoFile(file);

        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
          setGameLogoPreview(e.target.result);
        };
        reader.readAsDataURL(file);
      } catch (dimensionError) {
        setUploadError(dimensionError);
        showErrorNotification(dimensionError);
        // Clear the file input
        event.target.value = '';
      }
    }
  };

  const handleUpdate = async (shouldRefresh = false) => {
    if (!gameName.trim()) {
      const errorMsg = 'Game name is required';
      setUploadError(errorMsg);
      showErrorNotification(errorMsg);
      return;
    }

    if (!gameData?.id) {
      const errorMsg = 'Game ID is missing';
      setUploadError(errorMsg);
      showErrorNotification(errorMsg);
      return;
    }

    setIsUploading(true);
    setUploadError('');

    try {
      let firebaseImageUrl = gameData.logo; // Keep existing logo by default

      // Upload new image to Firebase if file is selected
      if (gameLogoFile) {
        const uploadResult = await FirebaseImageUpload(gameLogoFile);
        // Remove query parameters from Firebase URL as done in AdvBannersForm
        firebaseImageUrl = uploadResult.split('&')[0];
      }

      const gamePayload = {
        game_name: gameName,
        // Only include logo in payload if it's changed
        ...(gameLogoFile && { logo: firebaseImageUrl })
      };

      // Call API to update game
      const response = await Axios.put(`${base_url}/api/pot/games/${gameData.id}/`,
        gamePayload,
        Config
      );

      console.log(response, "update response");

      // If API call successful, create updated game object
      if (response.data) {
        const updatedGame = {
          ...gameData,
          game_name: gameName,
          logo: firebaseImageUrl,
          updated_at: new Date().toISOString(),
          updated_by: 'user',
          ...response.data // Include any additional data from API response
        };

        onSave(updatedGame);
        handleCancel(); // Reset form
        console.log('Game updated successfully:', response.data);
        if (shouldRefresh && onRefreshGames) {
          onRefreshGames();
        }
      }
    } catch (error) {
      console.error('Error updating game:', error);
      
      // Handle API error response
      let errorMessage = 'Failed to update game. Please try again.';
      
      if (error.response && error.response.data) {
        const { data } = error.response.data;
        
        // Handle the specific API error format
        if (data && data.game_name && Array.isArray(data.game_name)) {
          errorMessage = data.game_name.join(', ');
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      }
      
      setUploadError(errorMessage);
      showErrorNotification(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    setGameName('');
    setGameLogoFile(null);
    setGameLogoPreview('');
    setUploadError('');
    setIsUploading(false);
    setShowNotification(false);
    setNotificationMessage('');
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: '500px'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3,
              borderBottom: '1px solid #E5E7EB'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#1F2937'
              }}
            >
              Edit Sport
            </Typography>
            <IconButton
              onClick={handleCancel}
              disabled={isUploading}
              sx={{
                color: '#6B7280',
                '&:hover': { backgroundColor: '#F3F4F6' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Game Name Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Sport Name *
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter the sport name"
                value={gameName}
                onChange={(e) => setGameName(e.target.value)}
                disabled={isUploading}
                error={!gameName.trim() && uploadError.includes('Game name')}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    '& fieldset': {
                      borderColor: '#D1D5DB',
                    },
                    '&:hover fieldset': {
                      borderColor: '#9CA3AF',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3C50E0',
                    },
                  },
                  '& .MuiInputBase-input': {
                    padding: '12px 14px',
                    fontSize: '14px'
                  }
                }}
              />
            </Box>

            {/* Game Logo Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Sport Logo (Max: 100x100 pixels)
              </Typography>

              <Box
                sx={{
                  border: '2px dashed #D1D5DB',
                  borderRadius: '8px',
                  p: 4,
                  textAlign: 'center',
                  cursor: isUploading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  opacity: isUploading ? 0.6 : 1,
                  '&:hover': !isUploading && {
                    borderColor: '#9CA3AF',
                    backgroundColor: '#F9FAFB'
                  }
                }}
                onClick={() => !isUploading && document.getElementById('edit-file-upload').click()}
              >
                {isUploading ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                      Uploading image...
                    </Typography>
                  </Box>
                ) : gameLogoPreview ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <img
                      src={gameLogoPreview}
                      alt="Sport logo preview"
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'cover',
                        borderRadius: '8px'
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
                      Click to change logo
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                      Click to upload sport logo
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
                      PNG, JPG, GIF up to 10MB (Max: 100x100px)
                    </Typography>
                  </Box>
                )}

                <input
                  id="edit-file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  disabled={isUploading}
                  style={{ display: 'none' }}
                />
              </Box>

              {/* Error Message */}
              {uploadError && (
                <Typography
                  variant="body2"
                  sx={{
                    color: '#EF4444',
                    fontSize: '12px',
                    mt: 1
                  }}
                >
                  {uploadError}
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            borderTop: '1px solid #E5E7EB',
            justifyContent: 'flex-end',
            gap: 2
          }}
        >
          <Button
            onClick={handleCancel}
            disabled={isUploading}
            sx={{
              color: '#6B7280',
              backgroundColor: 'transparent',
              border: 'none',
              '&:hover': {
                backgroundColor: '#F9FAFB'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              px: 3
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleUpdate}
            disabled={!gameName.trim() || isUploading}
            sx={{
              backgroundColor: '#3C50E0',
              color: '#fff',
              '&:hover': { backgroundColor: '#2F4BCE' },
              '&:disabled': {
                backgroundColor: '#D1D5DB',
                color: '#9CA3AF'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              minWidth: '80px'
            }}
          >
            {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Component */}
      <Notification 
        show={showNotification}
        type={notificationType}
        message={notificationMessage}
        setopen={setShowNotification}
      />
    </>
  );
};

// CreateNewGameModal Component with Firebase Integration
// const CreateNewGameModal = ({ open, onClose, onSave, onRefreshGames }) => {
//   const [gameName, setGameName] = useState('');
//   const [gameLogoFile, setGameLogoFile] = useState(null);
//   const [gameLogoPreview, setGameLogoPreview] = useState('');
//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadError, setUploadError] = useState('');

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.startsWith('image/')) {
//         setUploadError('Please select an image file');
//         return;
//       }

//       // Validate file size (10MB limit)
//       if (file.size > 10 * 1024 * 1024) {
//         setUploadError('File size should be less than 10MB');
//         return;
//       }

//       setUploadError('');
//       setGameLogoFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setGameLogoPreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = async (shouldRefresh = false) => {
//     if (!gameName.trim()) {
//       setUploadError('Game name is required');
//       return;
//     }

//     setIsUploading(true);
//     setUploadError('');

//     try {
//       let firebaseImageUrl = '';

//       // Upload image to Firebase if file is selected
//       if (gameLogoFile) {
//         const uploadResult = await FirebaseImageUpload(gameLogoFile);
//         // Remove query parameters from Firebase URL as done in AdvBannersForm
//         firebaseImageUrl = uploadResult.split('&')[0];
//       }
//       //console.log("firebaseImageUrl", firebaseImageUrl)
//       const gamePayload = {
//         game_name: gameName,
//         status: false,
//         logo: firebaseImageUrl || 'default-game-logo.png' // Use Firebase URL or default
//       };
//       //console.log(gamePayload, "gamePayload")
//       // Call API to create game
//       // const response = await Axios.post(`${base_url}/api/pot/games/create/`,
//       //   gamePayload,
//       //   Config
//       // );
//       const response = await Axios.post(`${base_url}/api/pot/games/`,
//         gamePayload,
//         Config
//       );
//       console.log(response, "response11")

//       // If API call successful, create local game object
//       if (response.data) {
//         const newGame = {
//           id: response.data.id || Date.now(), // Use API response ID or fallback
//           game_name: gameName,
//           status: true,
//           logo: firebaseImageUrl || 'default-game-logo.png',
//           source: 'Manual',
//           isSelected: true, // Auto-select newly created game
//           created_at: new Date().toISOString(),
//           updated_at: new Date().toISOString(),
//           created_by: 'user',
//           updated_by: null,
//           ...response.data // Include any additional data from API response
//         };
//         onSave(newGame);
//         handleCancel(); // Reset form
//         console.log('Game created successfully:', response.data);
//         if (shouldRefresh && onRefreshGames) {
//           onRefreshGames();
//         }
//       }
//     } catch (error) {
//       console.error('Error uploading image:', error);
//       setUploadError('Failed to upload image. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleCancel = () => {
//     setGameName('');
//     setGameLogoFile(null);
//     setGameLogoPreview('');
//     setUploadError('');
//     setIsUploading(false);
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: '12px',
//           maxWidth: '500px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ p: 0 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             p: 3,
//             borderBottom: '1px solid #E5E7EB'
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: '18px',
//               color: '#1F2937'
//             }}
//           >
//             Create a new sport
//           </Typography>
//           <IconButton
//             onClick={handleCancel}
//             disabled={isUploading}
//             sx={{
//               color: '#6B7280',
//               '&:hover': { backgroundColor: '#F3F4F6' }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//           {/* Game Name Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Sport Name *
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter the sport name"
//               value={gameName}
//               onChange={(e) => setGameName(e.target.value)}
//               disabled={isUploading}
//               error={!gameName.trim() && uploadError.includes('Game name')}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '8px',
//                   '& fieldset': {
//                     borderColor: '#D1D5DB',
//                   },
//                   '&:hover fieldset': {
//                     borderColor: '#9CA3AF',
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: '#3C50E0',
//                   },
//                 },
//                 '& .MuiInputBase-input': {
//                   padding: '12px 14px',
//                   fontSize: '14px'
//                 }
//               }}
//             />
//           </Box>

//           {/* Game Logo Field */}
//           <Box>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#374151',
//                 fontWeight: 500,
//                 mb: 1
//               }}
//             >
//               Sport Logo
//             </Typography>

//             <Box
//               sx={{
//                 border: '2px dashed #D1D5DB',
//                 borderRadius: '8px',
//                 p: 4,
//                 textAlign: 'center',
//                 cursor: isUploading ? 'not-allowed' : 'pointer',
//                 transition: 'all 0.2s',
//                 opacity: isUploading ? 0.6 : 1,
//                 '&:hover': !isUploading && {
//                   borderColor: '#9CA3AF',
//                   backgroundColor: '#F9FAFB'
//                 }
//               }}
//               onClick={() => !isUploading && document.getElementById('file-upload').click()}
//             >
//               {isUploading ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                     Uploading image...
//                   </Typography>
//                 </Box>
//               ) : gameLogoPreview ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <img
//                     src={gameLogoPreview}
//                     alt="Game logo preview"
//                     style={{
//                       width: '60px',
//                       height: '60px',
//                       objectFit: 'cover',
//                       borderRadius: '8px'
//                     }}
//                   />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
//                     Click to change logo
//                   </Typography>
//                 </Box>
//               ) : (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
//                   <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
//                   <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
//                     Click to upload sport logo
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
//                     PNG, JPG, GIF up to 10MB
//                   </Typography>
//                 </Box>
//               )}

//               <input
//                 id="file-upload"
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFileUpload}
//                 disabled={isUploading}
//                 style={{ display: 'none' }}
//               />
//             </Box>

//             {/* Error Message */}
//             {uploadError && (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#EF4444',
//                   fontSize: '12px',
//                   mt: 1
//                 }}
//               >
//                 {uploadError}
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           p: 3,
//           borderTop: '1px solid #E5E7EB',
//           justifyContent: 'flex-end',
//           gap: 2
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           disabled={isUploading}
//           sx={{
//             color: '#6B7280',
//             backgroundColor: 'transparent',
//             border: 'none',
//             '&:hover': {
//               backgroundColor: '#F9FAFB'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 500,
//             px: 3
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleSave}
//           disabled={!gameName.trim() || isUploading}
//           sx={{
//             backgroundColor: '#3C50E0',
//             color: '#fff',
//             '&:hover': { backgroundColor: '#2F4BCE' },
//             '&:disabled': {
//               backgroundColor: '#D1D5DB',
//               color: '#9CA3AF'
//             },
//             borderRadius: '8px',
//             textTransform: 'none',
//             fontWeight: 600,
//             px: 3,
//             minWidth: '80px'
//           }}
//         >
//           {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

const CreateNewGameModal = ({ open, onClose, onSave, onRefreshGames }) => {
  const [gameName, setGameName] = useState('');
  const [gameLogoFile, setGameLogoFile] = useState(null);
  const [gameLogoPreview, setGameLogoPreview] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  
  // Notification states
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationType, setNotificationType] = useState('error');

  // Function to show notification
  const showErrorNotification = (message) => {
    setNotificationMessage(message);
    setNotificationType('error');
    setShowNotification(true);
  };

  // Function to validate image dimensions
  const validateImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        if (width > 100 || height > 100) {
          reject(`Image dimensions should not exceed 100x100 pixels. Current dimensions: ${width}x${height} pixels.`);
        } else {
          resolve();
        }
      };
      img.onerror = () => {
        reject('Error loading image for validation.');
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        const errorMsg = 'Please select an image file';
        setUploadError(errorMsg);
        showErrorNotification(errorMsg);
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        const errorMsg = 'File size should be less than 10MB';
        setUploadError(errorMsg);
        showErrorNotification(errorMsg);
        return;
      }

      try {
        // Validate image dimensions
        await validateImageDimensions(file);
        
        setUploadError('');
        setGameLogoFile(file);

        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
          setGameLogoPreview(e.target.result);
        };
        reader.readAsDataURL(file);
      } catch (dimensionError) {
        setUploadError(dimensionError);
        showErrorNotification(dimensionError);
        // Clear the file input
        event.target.value = '';
      }
    }
  };

  const handleSave = async (shouldRefresh = false) => {
    if (!gameName.trim()) {
      const errorMsg = 'Game name is required';
      setUploadError(errorMsg);
      showErrorNotification(errorMsg);
      return;
    }

    setIsUploading(true);
    setUploadError('');

    try {
      let firebaseImageUrl = '';

      // Upload image to Firebase if file is selected
      if (gameLogoFile) {
        const uploadResult = await FirebaseImageUpload(gameLogoFile);
        // Remove query parameters from Firebase URL as done in AdvBannersForm
        firebaseImageUrl = uploadResult.split('&')[0];
      }

      const gamePayload = {
        game_name: gameName,
        status: false,
        logo: firebaseImageUrl || 'default-game-logo.png'
      };

      const response = await Axios.post(`${base_url}/api/pot/games/`,
        gamePayload,
        Config
      );
      console.log(response, "response11")

      // If API call successful, create local game object
      if (response.data) {
        const newGame = {
          id: response.data.id || Date.now(),
          game_name: gameName,
          status: true,
          logo: firebaseImageUrl || 'default-game-logo.png',
          source: 'Manual',
          isSelected: true,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          created_by: 'user',
          updated_by: null,
          ...response.data
        };
        onSave(newGame);
        handleCancel();
        console.log('Game created successfully:', response.data);
        if (shouldRefresh && onRefreshGames) {
          onRefreshGames();
        }
      }
    } catch (error) {
      console.error('Error creating game:', error);
      
      // Handle API error response
      let errorMessage = 'Failed to create game. Please try again.';
      
      if (error.response && error.response.data) {
        const { data } = error.response.data;
        
        // Handle the specific API error format you showed
        if (data && data.game_name && Array.isArray(data.game_name)) {
          errorMessage = data.game_name.join(', ');
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      }
      
      setUploadError(errorMessage);
      showErrorNotification(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    setGameName('');
    setGameLogoFile(null);
    setGameLogoPreview('');
    setUploadError('');
    setIsUploading(false);
    setShowNotification(false);
    setNotificationMessage('');
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: '500px'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3,
              borderBottom: '1px solid #E5E7EB'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#1F2937'
              }}
            >
              Create a new sport
            </Typography>
            <IconButton
              onClick={handleCancel}
              disabled={isUploading}
              sx={{
                color: '#6B7280',
                '&:hover': { backgroundColor: '#F3F4F6' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Game Name Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Sport Name *
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter the sport name"
                value={gameName}
                onChange={(e) => setGameName(e.target.value)}
                disabled={isUploading}
                error={!gameName.trim() && uploadError.includes('Game name')}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    '& fieldset': {
                      borderColor: '#D1D5DB',
                    },
                    '&:hover fieldset': {
                      borderColor: '#9CA3AF',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3C50E0',
                    },
                  },
                  '& .MuiInputBase-input': {
                    padding: '12px 14px',
                    fontSize: '14px'
                  }
                }}
              />
            </Box>

            {/* Game Logo Field */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1
                }}
              >
                Sport Logo (Max: 100x100 pixels)
              </Typography>

              <Box
                sx={{
                  border: '2px dashed #D1D5DB',
                  borderRadius: '8px',
                  p: 4,
                  textAlign: 'center',
                  cursor: isUploading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  opacity: isUploading ? 0.6 : 1,
                  '&:hover': !isUploading && {
                    borderColor: '#9CA3AF',
                    backgroundColor: '#F9FAFB'
                  }
                }}
                onClick={() => !isUploading && document.getElementById('file-upload').click()}
              >
                {isUploading ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={40} sx={{ color: '#3C50E0' }} />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                      Uploading image...
                    </Typography>
                  </Box>
                ) : gameLogoPreview ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <img
                      src={gameLogoPreview}
                      alt="Game logo preview"
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'cover',
                        borderRadius: '8px'
                      }}
                    />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
                      Click to change logo
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <CloudUploadIcon sx={{ fontSize: 40, color: '#9CA3AF' }} />
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '14px' }}>
                      Click to upload sport logo
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '12px' }}>
                      PNG, JPG, GIF up to 10MB (Max: 100x100px)
                    </Typography>
                  </Box>
                )}

                <input
                  id="file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  disabled={isUploading}
                  style={{ display: 'none' }}
                />
              </Box>

              {/* Error Message */}
              {uploadError && (
                <Typography
                  variant="body2"
                  sx={{
                    color: '#EF4444',
                    fontSize: '12px',
                    mt: 1
                  }}
                >
                  {uploadError}
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            borderTop: '1px solid #E5E7EB',
            justifyContent: 'flex-end',
            gap: 2
          }}
        >
          <Button
            onClick={handleCancel}
            disabled={isUploading}
            sx={{
              color: '#6B7280',
              backgroundColor: 'transparent',
              border: 'none',
              '&:hover': {
                backgroundColor: '#F9FAFB'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              px: 3
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSave}
            disabled={!gameName.trim() || isUploading}
            sx={{
              backgroundColor: '#3C50E0',
              color: '#fff',
              '&:hover': { backgroundColor: '#2F4BCE' },
              '&:disabled': {
                backgroundColor: '#D1D5DB',
                color: '#9CA3AF'
              },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              minWidth: '80px'
            }}
          >
            {isUploading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Component */}
      <Notification 
        show={showNotification}
        type={notificationType}
        message={notificationMessage}
        setopen={setShowNotification}
      />
    </>
  );
};

const GamesModal = ({ open, onClose, onSave, data, onRefreshGames }) => {
  const [selectedGames, setSelectedGames] = useState([]);
  const [createNewGameOpen, setCreateNewGameOpen] = useState(false);
  const [editGameOpen, setEditGameOpen] = useState(false);
  const [editingGame, setEditingGame] = useState(null);
  const [allGames, setAllGames] = useState([]);

   // Add state for delete confirmation modal
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [gameToDelete, setGameToDelete] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState('');

  const transformApiData = (apiData) => {
    if (!apiData || !Array.isArray(apiData)) return [];

    return apiData.map(game => ({
      ...game,
      isSelected: game.status || false,
      source: 'API'
    }));
  };

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const transformedData = transformApiData(data);
      setAllGames(transformedData);

      // Initialize selected games based on status
      const selected = transformedData
        .filter(game => game.isSelected)
        .map(game => game.id);
      setSelectedGames(selected);
    }
  }, [data]);

  const handleGameToggle = (gameId) => {
    setSelectedGames(prev => {
      if (prev.includes(gameId)) {
        return prev.filter(id => id !== gameId);
      } else {
        return [...prev, gameId];
      }
    });

    // Update the allGames state to reflect the selection
    setAllGames(prev =>
      prev.map(game =>
        game.id === gameId
          ? { ...game, isSelected: !game.isSelected }
          : game
      )
    );
  };

  // const handleSave = () => {
  //   const selectedGamesData = allGames.filter(game => selectedGames.includes(game.id));
  //   onSave(selectedGamesData);
  //   onClose();
  // };

  // const handleSave = async () => {
  //   try {
  //     // Prepare payload: only selected games with status: true
  //     const selectedGamesData = allGames
  //       .filter(game => selectedGames.includes(game.id))
  //       .map(game => ({
  //         game_name: game.game_name,
  //         logo: game.logo,
  //         status: true
  //       }));
  // console.log(selectedGamesData, "selectedGamesData")
  //     // Send PUT request to API
  //     const response = await Axios.put(
  //       'https://sportspick-zkvkz.ondigitalocean.app/api/pot/games/',
  //       selectedGamesData,
  //       Config
  //     );
  // console.log(response, "responseselectedGamesData")
  //     if (response.status === 200 || response.status === 204) {
  //       console.log('Games published successfully');
  //       onRefreshGames(); // Optional: Refresh game list
  //       onClose();        // Close modal
  //     } else {
  //       console.error('Failed to update games:', response);
  //     }
  //   } catch (error) {
  //     console.error('Error while publishing games:', error);
  //   }
  // };

  // const handleSave = async () => {
  //   try {
  //     // Filter and prepare data for games with status true
  //     const selectedGamesData = allGames
  //       .filter(game => selectedGames.includes(game.id))
  //       .map(game => ({
  //         id: game.id, // Add id here to construct individual request URLs
  //         game_name: game.game_name,
  //         logo: game.logo,
  //         status: true
  //       }));

  //     //console.log(selectedGamesData, "selectedGamesData");

  //     // Loop through and update each game individually
  //     const updatePromises = selectedGamesData.map(game =>
  //       Axios.put(
  //         `${base_url}/api/pot/games/${game.id}/`,
  //         {
  //           game_name: game.game_name,
  //           logo: game.logo,
  //           status: game.status
  //         },
  //         Config
  //       )
  //     );

  //     // Wait for all requests to complete
  //     const results = await Promise.all(updatePromises);

  //     console.log('All games updated:', results);
  //     onRefreshGames();
  //     onClose();

  //   } catch (error) {
  //     console.error('Error while publishing games:', error);
  //   }
  // };

  const handleSave = async () => {
  try {
    // Filter games that have changed status
    const gamesToUpdate = allGames.filter(game => {
      const shouldBeSelected = selectedGames.includes(game.id);
      const currentStatus = game.status || false; // Original status from API
      
      // Only update if the status has changed
      return shouldBeSelected !== currentStatus;
    });

    console.log('Games to update:', gamesToUpdate);

    // If no games need updating, just close the modal
    if (gamesToUpdate.length === 0) {
      console.log('No games need updating');
      onClose();
      return;
    }

    // Prepare update promises for changed games only
    const updatePromises = gamesToUpdate.map(game => {
      const shouldBeSelected = selectedGames.includes(game.id);
      
      return Axios.put(
        `${base_url}/api/pot/games/${game.id}/`,
        {
          game_name: game.game_name,
          logo: game.logo,
          status: shouldBeSelected // true if selected, false if not selected
        },
        Config
      );
    });

    // Wait for all requests to complete
    const results = await Promise.all(updatePromises);

    console.log('Changed games updated:', results);
    onRefreshGames();
    onClose();

  } catch (error) {
    console.error('Error while publishing games:', error);
  }
};



  const handleCreateNew = () => {
    onClose();
    setCreateNewGameOpen(true);
  };

  const handleNewGameSave = (newGame) => {
    // Add the new game to allGames
    setAllGames(prev => [...prev, newGame]);
    setCreateNewGameOpen(false);
    // Auto-select the new game
    setSelectedGames(prev => [...prev, newGame.id]);
    // onOpen(); 
  };

  const handleNewGameClose = () => {
    setCreateNewGameOpen(false);
    // onOpen(); 
  };

  const handleEdit = (gameId) => {
    //console.log('Edit game:', gameId);
    // Find the game data to edit
    const gameToEdit = allGames.find(game => game.id === gameId);
    if (gameToEdit) {
      setEditingGame(gameToEdit);
      setEditGameOpen(true);
      onClose(); // Close the main games modal
    }
  };

  const handleEditGameSave = (updatedGame) => {
    // Update the game in allGames array
    setAllGames(prev =>
      prev.map(game =>
        game.id === updatedGame.id ? updatedGame : game
      )
    );
    setEditGameOpen(false);
    setEditingGame(null);
    // Reopen the main games modal
    // onOpen(); 
  };

  const handleEditGameClose = () => {
    setEditGameOpen(false);
    setEditingGame(null);
    // Reopen the main games modal
    // onOpen(); 
  };

  // const handleDelete = (gameId) => {
  //   // console.log('Delete game:', gameId);
  //   // Handle delete game logic
  //   setAllGames(prev => prev.filter(game => game.id !== gameId));
  //   setSelectedGames(prev => prev.filter(id => id !== gameId));
  // };


//   const handleDelete = async (gameId) => {
//   // Optional: Add confirmation dialog
//   if (window.confirm('Are you sure you want to delete this game?')) {
//     try {
//       // Make DELETE request to API
//       const response = await Axios.delete(
//         `https://sportspick-zkvkz.ondigitalocean.app/api/pot/games/${gameId}/`,
//         Config
//       );
// console.log(response, "responseDelete")
//       // Check if deletion was successful
//       if (response.status === 200 || response.status === 204) {
//         console.log('Game deleted successfully');
        
//         // Remove the game from local state
//         setAllGames(prev => prev.filter(game => game.id !== gameId));
//         setSelectedGames(prev => prev.filter(id => id !== gameId));
        
//         // Refresh games list (optional - to sync with latest API data)
//         onRefreshGames();
//       } else {
//         console.error('Failed to delete game:', response);
//       }
//     } catch (error) {
//       console.error('Error while deleting game:', error);
//       // Optional: Show error message to user
//       // You might want to show a toast notification or alert here
//     }
//   }
// };

  // Modified handleDelete to show confirmation modal
  const handleDelete = (gameId) => {
    const gameToDelete = allGames.find(game => game.id === gameId);
    if (gameToDelete) {
      setGameToDelete(gameToDelete);
      setDeleteMessage(`Are you sure you want to delete "${gameToDelete.game_name}"?`);
      setDeleteConfirmOpen(true);
    }
  };

  // Actual delete function after confirmation
  const confirmDelete = async () => {
    if (!gameToDelete) return;

    try {
      // Make DELETE request to API
      const response = await Axios.delete(
        `${base_url}/api/pot/games/${gameToDelete.id}/`,
        Config
      );
      
      console.log(response, "responseDelete");

      // Check if deletion was successful
      if (response.status === 200 || response.status === 204) {
        console.log('Game deleted successfully');
        
        // Remove the game from local state
        setAllGames(prev => prev.filter(game => game.id !== gameToDelete.id));
        setSelectedGames(prev => prev.filter(id => id !== gameToDelete.id));
        
        // Refresh games list (optional - to sync with latest API data)
        onRefreshGames();
      } else {
        console.error('Failed to delete game:', response);
      }
    } catch (error) {
      console.error('Error while deleting game:', error);
      // Optional: Show error message to user
    } finally {
      // Close confirmation modal and reset state
      setDeleteConfirmOpen(false);
      setGameToDelete(null);
      setDeleteMessage('');
    }
  };

  // Cancel delete action
  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setGameToDelete(null);
    setDeleteMessage('');
  };

  const getGameIcon = (iconType) => {
    if (typeof iconType === 'string' && iconType.startsWith('http')) {
      return (
        <img
          src={iconType}
          alt="Game icon"
          style={{
            width: 40,
            height: 40,
            objectFit: 'contain'
          }}
        />
      );
    }

    const iconProps = { sx: { fontSize: 24, color: '#6B7280' } };

    switch (iconType) {
      case 'football':
        return <SportsFootballIcon {...iconProps} />;
      case 'basketball':
        return <SportsBasketballIcon {...iconProps} />;
      case 'hockey':
        return <SportsHockeyIcon {...iconProps} />;
      case 'baseball':
        return <SportsBaseballIcon {...iconProps} />;
      case 'tennis':
        return <SportsFootballIcon {...iconProps} />;
      case 'cricket':
        return <SportsBaseballIcon {...iconProps} />;
      default:
        return <SportsFootballIcon {...iconProps} />;
    }
  };

  // console.log('All Games:', allGames);
  // console.log('Selected Games:', selectedGames);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3,
              borderBottom: '1px solid #E5E7EB'
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#1F2937',
                  mb: 0.5
                }}
              >
                Listing preferred sports from API
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#6B7280',
                  fontSize: '14px'
                }}
              >
                Selected sports will be published
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, paddingTop: "20px" }}>
              <TransButton
                title="Create New Sport +"
                onClick={handleCreateNew}
                sx={{
                  background: "none",
                  border: "1px solid #3C50E0",
                  color: "#3C50E0",
                  '&:hover': {
                            backgroundColor: '#F3F4F6',
                            color: '#3C50E0'
                          }
                }}
              />
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 3 }}>
            {allGames.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" sx={{ color: '#6B7280' }}>
                  No sports available
                </Typography>
              </Box>
            ) : (
              allGames.map((game, index) => (
                <Box key={game.id}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      py: 2,
                      px: 1
                    }}
                  >
                    <Checkbox
                      checked={selectedGames.includes(game.id)}
                      onChange={() => handleGameToggle(game.id)}
                      sx={{
                        color: '#D1D5DB',
                        '&.Mui-checked': {
                          color: '#3C50E0',
                        },
                        mr: 2
                      }}
                    />

                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          fontSize: '16px',
                          color: '#1F2937'
                        }}
                      >
                        {game.game_name}
                      </Typography>
                    </Box>

                    {game.logo && (game.logo.startsWith('http') || game.logo.startsWith('https://firebasestorage.googleapis.com')) ? (
                      <Avatar
                        sx={{
                          width: 50,
                          height: 40,
                          mr: 33,
                          backgroundColor: '#F3F4F6',
                          '& img': {
                            objectFit: 'contain',
                            width: '80%',
                            height: '80%'
                          }
                        }}
                        src={game.logo}
                        alt={game.game_name}
                      />
                    ) : (
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          mr: 33,
                          backgroundColor: '#F3F4F6'
                        }}
                      >
                        {getGameIcon(game.logo)}
                      </Avatar>
                    )}
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#6B7280',
                        fontSize: '14px',
                        mr: 3,
                        minWidth: '60px'
                      }}
                    >
                      {game.source}
                    </Typography>

                    <Stack direction="row" spacing={1}>
                      <IconButton
                        onClick={() => handleEdit(game.id)}
                        size="small"
                        sx={{
                          color: '#6B7280',
                          '&:hover': {
                            backgroundColor: '#F3F4F6',
                            color: '#3C50E0'
                          }
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        onClick={() => handleDelete(game.id)}
                        size="small"
                        sx={{
                          color: '#6B7280',
                          '&:hover': {
                            backgroundColor: '#FEF2F2',
                            color: '#EF4444'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </Box>

                  {index < allGames.length - 1 && (
                    <Divider sx={{ mx: 1 }} />
                  )}
                </Box>
              ))
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            borderTop: '1px solid #E5E7EB',
            justifyContent: 'flex-end',
            gap: 2
          }}
        >
          <TransButton
            title="Publish"
            onClick={handleSave}
          />
          <TransButton
            title="Cancel"
            onClick={onClose}
            sx={{
              background: "none",
              border: "1px solid #1C2434",
              color: "#1C2434",
              '&:hover': {
                background: "none"
              }
            }}
          />
        </DialogActions>
      </Dialog>

      {/* CreateNewGameModal */}
      <CreateNewGameModal
        open={createNewGameOpen}
        onClose={handleNewGameClose}
        onSave={handleNewGameSave}
        onRefreshGames={onRefreshGames}
      />

      {/* EditGameModal */}
      <EditGameModal
        open={editGameOpen}
        onClose={handleEditGameClose}
        onSave={handleEditGameSave}
        gameData={editingGame}
        onRefreshGames={onRefreshGames}
      />

      <ModalPopUp
        openpopup={deleteConfirmOpen}
        setPopup={setDeleteConfirmOpen}
        title={'Confirm Delete'}
        subTitle={deleteMessage}
        onClick={confirmDelete}
        save={'Delete'}
        cancel={'Cancel'}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default GamesModal;